import { render, staticRenderFns } from "./MoreActionsForMarketplace.vue?vue&type=template&id=0daf7b7d&scoped=true"
import script from "./MoreActionsForMarketplace.vue?vue&type=script&lang=js"
export * from "./MoreActionsForMarketplace.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0daf7b7d",
  null
  
)

export default component.exports